module.exports = __webpack_public_path__ + "static/media/new_banner.0bff9358.jpg";